module.exports = __webpack_public_path__ + "img/img-main-bg-08.4e6fa14d.png";